export default __webpack_public_path__ + "static/media/travelportLogo.f9af9a58.png";